import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { ConsumptionSummary } from '@/types/consumption';

export function useConsumptionSummary() {
  return useQuery<ConsumptionSummary>({
    queryKey: ['consumption', 'summary'],
    queryFn: async () => {
      const { data } = await api.get<ConsumptionSummary>('/consumption/summary');
      return data;
    },
    staleTime: 60_000,
  });
}
